import { useState, useEffect, createContext, useContext } from 'react';
import { majorTokensLookup, mCoinsData } from '../data/tokenData';
import { addCommas } from '../utils/tools';
import VehicleCatalogDefault, { VehicleCatalog, getRandomVehicleRoute } from '../data/vehicles';
import { cityConfig } from '../data/scenes';

const dexscreenerApiBase = 'https://api.dexscreener.com/latest/dex';


const { CharacterCatalog } = require('../data/characters');

export const dataContext = createContext();


export const useProvideData = () => {

    const [majorCoins, setMajorCoins] = useState({...mCoinsData});
    const [cameraMode, setCameraMode] = useState('locked');
    const [allowModeToggle, setAllowModeToggle] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [vehiclesArchive, setVehiclesArchive] = useState([]);
    const [vehiclesCasted, setVehiclesCasted] = useState([]);

    const addVehicle = (vehicle) => {
      setVehicles(prev => [...prev, vehicle]);
      setVehiclesCasted(prev => [...prev, vehicle.vehicleKey]);
    };

    const removeVehicle = (id) => {
      if (typeof window !== 'undefined' && window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          setVehicles(prev => prev.filter(v => v.id !== id));
        });
      } else {
        setVehicles(prev => prev.filter(v => v.id !== id));
      }
    };

    const clearVehicles = () => {
      setVehicles([]);
    };

    const [characters, setCharacters] = useState([]);
    const [charactersArchive, setCharactersArchive] = useState([]);
    const [charactersCasted, setCharactersCasted] = useState([]);
    const [missionActive, setMissionActive] = useState(false);
    const [currentCharacter, setCurrentCharacter] = useState(null);
    const [currentMission, setCurrentMission] = useState(null);
    
    const addCharacter = (character) => {
      if (typeof window !== 'undefined' && window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          setCharacters(prev => [...prev, character]);
          setCharactersCasted(prev => [...prev, character.characterKey]);
        });
      } else {
        setCharacters(prev => [...prev, character]);
        setCharactersCasted(prev => [...prev, character.characterKey]);
      }
    };

    const removeCharacter = (id) => {
      if (typeof window !== 'undefined' && window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          setCharacters(prev => prev.filter(c => c.id !== id));
        });
      } else {
        setCharacters(prev => prev.filter(c => c.id !== id));
      }
    };

    const clearCharacters = () => {
      setCharacters([]);
    };

    const [missions, setMissions] = useState([

    ]);

  


    const addMission = (position) => {
      setMissions([...missions, { position: position, id: `mission_${missions.length + 1}` }]);
    };
    const removeMission = (id) => {
      setMissions(missions.filter(mission => mission.id !== id));
    };

    const clearMissions = () => {
      setMissions([]);
    };

  const claimMission = (missionId) => {
    setMissions(prev => prev.filter(m => m.id !== missionId));
  };

  // Initialize cameraMode from URL (?controls=flying) and whether Tab mode toggle is allowed
  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search)
        const controls = params.get('controls')
        const adminParam = params.get('admin')
        if (controls && controls.toLowerCase() === 'flying') {
          setCameraMode('flying')
          setAllowModeToggle(true)
        } else {
          setAllowModeToggle(false)
        }
        if (adminParam && /^(1|true|yes)$/i.test(adminParam)) {
          setIsAdmin(true)
        }
      }
    } catch (e) {
      // noop
    }
  }, [])

  // Keep character positions in sync so missions can target current location
  const updateCharacterPosition = (characterId, position) => {
    if (!characterId || !Array.isArray(position)) return;
    setCharacters(prev => prev.map(c => c.id === characterId ? { ...c, position } : c));
  };

  const archiveCharacter = (characterId) => {
    if (!characterId) return;
    setCharacters(prev => {
      const idx = prev.findIndex(c => c.id === characterId);
      if (idx === -1) return prev;
      const charObj = prev[idx];
      setCharactersArchive(prevArch => [charObj, ...prevArch].slice(0, 100)); // keep last 100
      const copy = [...prev];
      copy.splice(idx,1);
      return copy;
    });
  };

  // Lock a character in place for pickup: stop movement/animations and mark waitingForBeam
  const lockCharacter = (characterId) => {
    if (!characterId) return;
    setCharacters(prev => prev.map(c => c.id === characterId ? {
      ...c,
      waitingForBeam: true,
      pickupScheduled: true,
      waypointsEnabled: false
    } : c));
  };

  // Get the latest position for a character
  const getCharacterPosition = (characterId) => {
    if (!characterId) return null;
    const c = characters.find(ch => ch.id === characterId);
    return c && Array.isArray(c.position) ? c.position : null;
  };

    useEffect(() => {
      fetchMajorCoins();

      // Set up 3-minute interval for fetchMajorCoins
      const coinInterval = setInterval(() => {
        // console.log('💰 Fetching major coins data (3min interval)');
        fetchMajorCoins();
      }, 3 * 60 * 1000); // 3 minutes

      const startCastingCharacters = () => {
        composeCharacterEntrance();
        const scheduleNext = () => {
          const delay = 3000 + Math.random() * 11000; // 3-8 seconds
          composeCharacterEntrance();
          setTimeout(() => {
            // console.log('🔄 Random timeout fired!');
            scheduleNext(); // Schedule the next one
          }, delay);
        };
        scheduleNext();
      };

      const startCastingVehicles = () => {
        const spawn = () => {
          composeVehicleEntrance();
          setTimeout(spawn, 11000 + Math.random()*11000);
        };
        spawn();
      };
       

      if (typeof window !== 'undefined' && window.__portalRevealed) {
        startCastingCharacters();
        startCastingVehicles();
      } else if (typeof window !== 'undefined') {
        const handler = () => {
          startCastingCharacters();
          startCastingVehicles();
          window.removeEventListener('portal:revealed', handler);
        };
        window.addEventListener('portal:revealed', handler);
      }

      // Cleanup function
      return () => {
        clearInterval(coinInterval);
      };
    }, []);

    const getRandomPosition = () => {

      const parkCenterX = 0;
      const parkCenterZ = -17;
      const parkRadius = 33;
      
      const angle = Math.random() * Math.PI * 2;
      const distance = Math.random() * parkRadius;
      const randomX = parkCenterX + Math.cos(angle) * distance;
      const randomZ = parkCenterZ + Math.sin(angle) * distance;
      return [randomX, 0, randomZ];
    };

    const composeVehicleEntrance = () => {
      setVehicles(prev => {
        const limit = 4;
        if (prev.length >= limit) return prev;
        const keys = Object.keys(VehicleCatalog || VehicleCatalogDefault || {});
        if (keys.length === 0) return prev;
        // Avoid duplicates: pick from keys not currently present
        const existing = new Set(prev.map(v => v.key));
        const available = keys.filter(k => !existing.has(k));
        if (available.length === 0) return prev;
        const key = available[Math.floor(Math.random()*available.length)];
        const entry = (VehicleCatalog || VehicleCatalogDefault)[key];
        if (!entry) return prev;
        const id = `veh_${key}_${Date.now()}`;
        const route = getRandomVehicleRoute(key);
        const v = {
          id,
          key,
          glbUrl: entry.glb,
          position: route[0] || [0,0,0],
          rotation: entry.rotation || [0,0,0],
          scale: entry.scale || [1,1,1],
          offsetPosition: entry.offsetPosition || [0,0,0],
          speed: entry.speed || 6,
          route,
        };
        return [...prev, v];
      });
    };

    const composeCharacterEntrance = () => {
      // Use functional update to check current state, not stale closure value
      setCharacters(prevCharacters => {
        let readyToEnter = true;
        const characterLimit = 3;

        // Current active characters eligible for pickup (inScene and not already scheduled/waiting)
        const activeChars = prevCharacters.filter(c => c.inScene && !c.pickupScheduled && !c.waitingForBeam);

        for (let i = 0; i < prevCharacters.length; i++) {
          if (!prevCharacters[i].inScene) {
            readyToEnter = false;
            break;
          }
        }

        // If we are at or above limit, dispatch a pickup mission for the oldest active character
        if (activeChars.length >= characterLimit) {
          const candidate = activeChars[0];
          if (candidate) {
            const now = Date.now();
            const missionPosition = candidate.position || [0, 0, 0];
            const mission = { type: 'pickup', position: missionPosition, id: `mission_${now}`, characterKey: candidate.characterKey, characterId: candidate.id };
            setMissions(prevMissions => [...prevMissions, mission]);
            // Schedule pickup but do not start beam/despawn visuals until UFO beam latches
            return prevCharacters.map(c => c.id === candidate.id ? { ...c, pickupScheduled: true, waypointsEnabled: false } : c);
          }
          return prevCharacters;
        }

        if (readyToEnter) {
          const characterKeys = Object.keys(CharacterCatalog);
          const randomCharacterKey = characterKeys[Math.floor(Math.random() * characterKeys.length)];
          const selectedCharacter = CharacterCatalog[randomCharacterKey];

          let now = Date.now();

          // Randomized dropoff anywhere in park area
          const missionPosition = getRandomPosition();
          const characterId = `character_${now}`;
          const mission = { type: 'dropoff', position: missionPosition, id: `mission_${now}`, characterKey: randomCharacterKey, characterId };
          
          // Use functional update for missions too
          setMissions(prevMissions => [...prevMissions, mission]);

          const characterData = {
            ...selectedCharacter,
            id: characterId,
            visible: true,
            inScene: false,
            waitingForBeam: false,
            startIdle: true,
            waypointsEnabled: false,
            enteredAt: now,
            exitedAt: null,
            position: missionPosition,
            characterKey: randomCharacterKey,
          };

          // console.log('🎭 Adding character:', characterData.name, 'Total characters before:', prevCharacters.length);
          // console.log('🎭 Character added:', characterData.name, 'Total characters now:', prevCharacters.length + 1);
          
          // Add character to array
          setCharactersCasted(prevCasted => [...prevCasted, characterData.characterKey]);
          
          // Return updated array with new character
          return [...prevCharacters, characterData];
        }
        
        // If not ready, return unchanged
        return prevCharacters;
      });
    };


    const completeMission = () => {
      // console.log('🎭 Completing mission:', currentMission);
   
      
      // Clean up mission
      setMissionActive(false);
      setCurrentCharacter(null);
      setCurrentMission(null);
    };

  // Mark the most recently added character as in-scene at a given beam position
  const markLastCharacterInScene = (beamPosition, missionId) => {
    setCharacters(prev => {
      if (prev.length === 0) return prev;
      let idx = prev.length - 1;
      // If missionId provided, map it to a characterId via missions list (may be missing if mission was claimed)
      if (missionId) {
        const m = missions.find(ms => ms.id === missionId);
        if (m && m.characterId) {
          const foundIdx = prev.findIndex(c => c.id === m.characterId);
          if (foundIdx !== -1) idx = foundIdx;
        } else {
          // Fallback: choose the nearest character that is not yet inScene
          let bestIdx = -1;
          let bestDist = Infinity;
          for (let i = 0; i < prev.length; i++) {
            const c = prev[i];
            if (c.inScene) continue;
            const dx = (c.position?.[0] ?? 0) - beamPosition[0];
            const dz = (c.position?.[2] ?? 0) - beamPosition[2];
            const d2 = dx*dx + dz*dz;
            if (d2 < bestDist) {
              bestDist = d2;
              bestIdx = i;
            }
          }
          if (bestIdx !== -1) idx = bestIdx;
        }
      }
      const updated = [...prev];
      updated[idx] = {
        ...updated[idx],
        inScene: true,
        visible: true,
        position: [beamPosition[0], 0, beamPosition[2]]
      };
      return updated;
    });
  };

  

    const enableCharacterWaypoints = (characterId, beamPosition) => {
      // Find character by ID
      const character = characters.find(char => char.id === characterId);
      
      if (!character) {
        // console.log('🎭 Character not found!');
        return;
      }
      
      // Update character position to beam bottom and make visible
      const updatedCharacter = {
        ...character,
        position: [beamPosition[0], 0, beamPosition[2]], // Ground level under beam
        visible: true, // Reveal character when beam activates
        inScene: true // Mark as in scene so new characters can enter
      };
      
      // Update in characters array
      setCharacters(prevCharacters => {
        const updatedCharacters = prevCharacters.map(char => 
          char.id === characterId ? updatedCharacter : char
        );
        return updatedCharacters;
      });
      
      // Enable waypoints after a delay (3-5 seconds)
      const waypointDelay = 3000 + Math.random() * 2000; // 3-5 seconds
      setTimeout(() => {
        setCharacters(prevCharacters => {
          const characterWithWaypoints = {
            ...updatedCharacter,
            waypointsEnabled: true
          };
          
          const finalCharacters = prevCharacters.map(char => 
            char.id === characterId ? characterWithWaypoints : char
          );
          
          // console.log('🎭 Character waypoints enabled after delay:', character.name);
          return finalCharacters;
        });
      }, waypointDelay);
      
      // console.log('🎭 Character revealed and positioned at beam:', beamPosition);
      // console.log(`🎭 Waypoints will be enabled in ${Math.round(waypointDelay/1000)} seconds`);
    };

    const fetchMajorCoins = async () => {
  
      let solDataUrl = `${dexscreenerApiBase}/pairs/solana/${majorTokensLookup.btc.pairAddress},${majorTokensLookup.bnb.pairAddress},${majorTokensLookup.eth.pairAddress}`;
      let bscDataUrl = `${dexscreenerApiBase}/pairs/bsc/${majorTokensLookup.xrp.pairAddress},${majorTokensLookup.sol.pairAddress}`;
      let ethDataUrl = `${dexscreenerApiBase}/pairs/ethereum/${majorTokensLookup.monster.pairAddress}`;
   
      let mc = {...mCoinsData};

      const solResponse = await fetch(solDataUrl);
      const solData = await solResponse.json();
      const bscResponse = await fetch(bscDataUrl);
      const bscData = await bscResponse.json();

      const ethResponse = await fetch(ethDataUrl);
      const ethData = await ethResponse.json();

  
      if(solData.pairs && solData.pairs.length > 1) {
        mc.btc.price = solData.pairs[0].priceUsd;
        mc.btc.percent = solData.pairs[0].priceChange.h24;
        mc.bnb.price = solData.pairs[1].priceUsd;
        mc.bnb.percent = solData.pairs[1].priceChange.h24;
        mc.eth.price = solData.pairs[2].priceUsd;
        mc.eth.percent = solData.pairs[2].priceChange.h24;
      }
      
      if(bscData.pairs && bscData.pairs.length > 0) {
        mc.xrp.price = bscData.pairs[0].priceUsd;
        mc.xrp.percent = bscData.pairs[0].priceChange.h24;
        mc.sol.price = bscData.pairs[1].priceUsd;
        mc.sol.percent = bscData.pairs[1].priceChange.h24;
      }

      if(ethData.pairs && ethData.pairs.length > 0) {
        mc.monster.price = ethData.pairs[0].priceUsd;
        mc.monster.percent = ethData.pairs[0].priceChange.h24;
      }

      let mcData = Object.values(mc).map(coin => ({
        logo: coin.logo,
        name: coin.name,
        price: Number(coin.price) < 100 && Number(coin.price) >= 1 ? Number(coin.price).toFixed(2) : Number(coin.price) < 1 ? Number(coin.price).toFixed(6) : addCommas(Number(coin.price).toFixed(0)),
        percent: addCommas(coin.percent)
      }));
   
      setMajorCoins(mcData);
  
    };
  
    
  
    return {
      majorCoins,
      cameraMode,
      setCameraMode,
      allowModeToggle,
      isAdmin,
      characters,
      addCharacter,
      removeCharacter,
      clearCharacters,
      missions,
      charactersArchive,
      addMission,
      removeMission,
      claimMission,
      clearMissions,
      // Random mission system
      missionActive,
      currentCharacter,
      currentMission,
      completeMission,
      // Character waypoint system
      enableCharacterWaypoints,
      markLastCharacterInScene,
      updateCharacterPosition,
      archiveCharacter,
      vehicles,
      setVehicles,
      removeVehicle,
      lockCharacter,
      getCharacterPosition
    };
};



// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideData({ children }) {
    const data = useProvideData();
    return <dataContext.Provider value={data}>{children}</dataContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useData = () => {
    return useContext(dataContext);
};
